import { Button, Container } from "@mui/material";

export default function LaunchSignInAlt() {
  const handleAltSignIn = () => {
    window.open("mypav://mypav.com/signInAlt", "_blank");
  };
  return (
    <div>
      <Container>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAltSignIn}
          style={{ marginTop: 50 }}
        >
          Open Alternate Sign In
        </Button>
      </Container>
    </div>
  );
}
